import {useEffect, useRef} from "react";
import {router} from "@inertiajs/react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";
import {useSearchStore} from "@/Stores/Site/Search"; // Legacy
import {selectGetSearchData} from "@/Stores/Site/Search/Selectors"; // Legacy

export const useBrowserHistoryNavigation = () => {
    const {basketStore} = useStoreMobx();

    const searchStoreGetSearchData = useSearchStore(selectGetSearchData);

    const isHistoryNavigation = useRef(false);

    useEffect(() => {

        const handlePopstate = () => {
            isHistoryNavigation.current = true;
        };

        const removeNavigateListener = router.on('navigate', (event) => {
            if (!isHistoryNavigation.current) {
                return;
            }

            // Сбрасываем флаг до выполнения действий, чтобы router.reload() не запустил повторную обработку.
            isHistoryNavigation.current = false;

            const pathname = new URL(
                event.detail.page.url,
                window.location.origin,
            ).pathname;

            if (pathname === '/basket') {
                basketStore.getBasket(true);
                return;
            }

            if (pathname === '/go-to-checkout') {
                basketStore.getBasketGoToCheckout(true);
                return;
            }

            if (pathname === '/search') {
                searchStoreGetSearchData(true);
                return;
            }

            // По умолчанию запрашиваем свежие props страницы.
            router.reload();
        });

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
            removeNavigateListener();
        };
    }, [basketStore, searchStoreGetSearchData]);
};
